import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { NotificationTray, NotificationBadge } from 'components/Notifications';
import Button from 'components/CncUI/Button';
import useMutation from 'hooks/useMutation';
import clsx from 'classnames';

import useGetMyNotifications from './utils/useGetMyNotifications';

const useStyles = makeStyles(({ palette }) => ({
  button: {
    color: palette.cncUI.default['+10'],
    '&:hover, &:focus, &:active': {
      color: palette.cncUI.default['+10'],
    },
    '&:hover': {
      backgroundColor: palette.cncUI.default['+3'],
    },
    '&:focus': {
      borderColor: 'transparent',
      boxShadow: 'none',
    },
    height: 60,
    minWidth: 60,
  },
  open: {
    backgroundColor: palette.cncUI.default['-3'],
  },
}));

const NotificationsMenu = () => {
  const classes = useStyles();
  const [
    { notifications = [], userSettings = {}, timestamp: fetchTimestamp },
    loading,
    refetch,
  ] = useGetMyNotifications();
  const [anchorEl, setAnchorEl] = useState(null);

  const updateLastReadNotifications = useMutation('updateUserSettings', {
    scopes: 'openid',
    request: (settings, lastReadTimestamp) => ({
      settings: JSON.stringify({
        ...settings,
        lastReadNotifications: lastReadTimestamp,
      }),
    }),
    response: res => res.data.id,
  });

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = async () => {
    setAnchorEl(null);
    await updateLastReadNotifications(userSettings, fetchTimestamp);
    await refetch();
  };

  const id = open ? 'simple-popover' : undefined;
  const trayOpen = Boolean(anchorEl);

  if (loading)
    return (
      <Button className={classes.button} tertiary onClick={() => {}}>
        <NotificationBadge notifications={[]} />
      </Button>
    );

  return (
    <>
      <Button
        className={clsx(classes.button, trayOpen && classes.open)}
        aria-describedby={id}
        tertiary
        data-test-id={`NotificationsMenu-button`}
        key={`NotificationsMenu-button`}
        onClick={handleClick}
      >
        <NotificationBadge notifications={notifications} />
      </Button>
      <NotificationTray
        anchorEl={anchorEl}
        handleClose={handleClose}
        notifications={notifications}
        loading={loading}
      />
    </>
  );
};

export default NotificationsMenu;
